type UnknownRecord = Record<string, unknown>;

export interface MaterialGenerationErrorInfo {
	status?: number;
	code?: string;
	message?: string;
}

function asRecord(value: unknown): UnknownRecord | undefined {
	return typeof value === 'object' && value !== null ? (value as UnknownRecord) : undefined;
}

function numericStatus(value: unknown): number | undefined {
	return typeof value === 'number' ? value : undefined;
}

export function getMaterialGenerationErrorInfo(error: unknown): MaterialGenerationErrorInfo {
	const errorRecord = asRecord(error);
	if (!errorRecord) {
		return {};
	}

	const responseRecord = asRecord(errorRecord.response);
	const bodyRecord = asRecord(errorRecord.body) ?? asRecord(responseRecord?.body);
	const detail = bodyRecord?.detail ?? errorRecord.detail;
	const detailRecord = asRecord(detail);

	return {
		status: numericStatus(errorRecord.status) ?? numericStatus(responseRecord?.status),
		code: typeof detailRecord?.code === 'string' ? detailRecord.code : undefined,
		message:
			typeof detailRecord?.message === 'string'
				? detailRecord.message
				: typeof detail === 'string'
					? detail
					: undefined
	};
}
